import Info from '@/layout/info/Info.vue'
import store from '@/store/store'
import ListarBoletosNaoEncontrados from '@/views/boletosNaoEncontrados/ListarBoletosNaoEncontrados.vue'
import ListarCancelarTrp from '@/views/cancelarTrp/ListarCancelarTrp.vue'
import ComunicacaoTransferencia from '@/views/comunicacaoTransferencia/ComunicacaoTransferencia.vue'
import ComunicacaoTransferenciaExecucaoFiscalSefa from '@/views/comunicacaoTransferenciaExecucaoFiscalSefa/ComunicacaoTransferenciaExecucaoFiscalSefa.vue'
import ListarCdaWebService from '@/views/consultaCdaWebService/ListarCdaWebService.vue'
import ConsultaBoletoExterno from '@/views/consultaBoletoExterno/ConsultaBoletoExterno.vue'
import EditarDevedor from '@/views/devedor/DevedorEditar.vue'
import ListarDevedor from '@/views/devedor/ListarDevedor.vue'
import Home from '@/views/home/Home.vue'
import IniciarRequisicao from '@/views/honorarios/IniciarRequisicao.vue'
import HonorariosAcaoJudicial from '@/views/honorariosAcaoJudicial/HonorariosAcaoJudicial.vue'
import HonorariosExecucaoFiscalSefa from '@/views/honorariosExecucaoFiscalSefa/HonorariosExecucaoFiscalSefa.vue'
import HonorariosProtesto from '@/views/honorariosProtesto/HonorariosProtesto.vue'
import IncluirPercentual from '@/views/indice/IncluirPercentual.vue'
import ListarIndice from '@/views/indice/ListarIndice.vue'
import ListarMigracaoGuias from '@/views/migracaoGuias/ListarMigracaoGuias.vue'
import PainelTesoureiro from '@/views/painelTesoureiro/PainelTesoureiro.vue'
import PainelUsuario from '@/views/painelUsuario/PainelUsuario.vue'
import ParametroCredorBancario from '@/views/parametros/ParametroCredorBancario.vue'
import ParametroCredorBancarioCES from '@/views/parametros/ParametroCredorBancarioCES.vue'
import ParametroParcelamento from '@/views/parametros/ParametroParcelamento.vue'
import Pesquisas from '@/views/pesquisas/Pesquisas.vue'
import IncluirReceitasDiversas from '@/views/receitas/IncluirReceitasDiversas.vue'
import ListarRegrasPagamento from '@/views/regrasPagamento/ListarRegrasPagamento.vue'
import RegrasPagamentoEditar from '@/views/regrasPagamento/RegrasPagamentoEditar.vue'
import RegrasPagamentoExibir from '@/views/regrasPagamento/RegrasPagamentoExibir.vue'
import ListarTipoTrp from '@/views/tipoTrp/ListarTipoTrp.vue'
import TipoTrpEditar from '@/views/tipoTrp/TipoTrpEditar.vue'
import TipoTrpExibir from '@/views/tipoTrp/TipoTrpExibir.vue'
import Trp from '@/views/trp/Trp.vue'
import Vue from 'vue'
import Router from 'vue-router'
import ListarCargaRefis from "../views/cargaRefis/ListarCargaRefis"
import ListarSalarioMinimo from "../views/salarioMinimo/ListarSalarioMinimo"
import SalarioMinimoEditar from "../views/salarioMinimo/SalarioMinimoEditar"

// error pages
import AccessDenied from '@/layout/errors/Deny'
import NotFound from '@/layout/errors/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Inicial',
      component: Home,
      meta: {
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
      }
    },
    {
      path: '/painel-tesoureiro',
      name: 'painel-tesoureiro',
      component: PainelTesoureiro,
      //component: Home,
      meta: {
        breadcrumb: true,
        label: 'Painel do Tesoureiro',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
      }
    },
    {
      path: '/info',
      name: 'Informações',
      component: Info,
      meta: {
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        breadcrumb: true,
        label: 'Página Inicial',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
      }
    },
    {
      path: '/regras-pagamento',
      name: 'regras-pagamento',
      component: ListarRegrasPagamento,
      meta: {
        breadcrumb: true,
        label: 'Regras de Pagamento',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/regras-pagamento/incluir',
      name: 'regras-pagamento-incluir',
      component: RegrasPagamentoEditar,
      meta: {
        breadcrumb: true,
        label: 'Incluir Regras de Pagamento',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/regras-pagamento/editar',
      name: 'regras-pagamento-editar',
      component: RegrasPagamentoEditar,
      meta: {
        breadcrumb: true,
        label: 'Editar Regras de Pagamento',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/regras-pagamento/exibir',
      name: 'regras-pagamento-exibir',
      component: RegrasPagamentoExibir,
      meta: {
        breadcrumb: true,
        label: 'Exibir Regras de Pagamento',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/receitas-diversas',
      name: 'receitas-diversas',
      component: IncluirReceitasDiversas,
      meta: {
        breadcrumb: true,
        label: 'Gerar Registro de Ingresso de Receita Diversa',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
      }
    },
    {
      path: '/devedor',
      name: 'devedor',
      component: ListarDevedor,
      meta: {
        breadcrumb: true,
        label: 'Cadastro de Devedor',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/devedor/incluir',
      name: 'devedor-incluir',
      component: EditarDevedor,
      meta: {
        breadcrumb: true,
        label: 'Incluir Devedor',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/devedor/editar',
      name: 'devedor-editar',
      component: EditarDevedor,
      meta: {
        breadcrumb: true,
        label: 'Editar Devedor',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/indice',
      name: 'indice',
      component: ListarIndice,
      meta: {
        breadcrumb: true,
        label: 'Alteração de Índice',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
      }
    },
    {
      path: '/indice/percentual',
      name: 'indicePercentual',
      component: IncluirPercentual,
      meta: {
        breadcrumb: true,
        label: 'Incluir Percentual',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
      }
    },
    {
      path: '/email-devedor',
      name: 'emailDevedor',
      component: ParametroParcelamento,
      meta: {
        breadcrumb: true,
        label: `E-mail's ao Devedor`,
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/parametro-credor',
      name: 'parametroCredorBancario',
      component: ParametroCredorBancario,
      meta: {
        breadcrumb: true,
        label: 'Parâmetros de Credor e Dados Bancários',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/parametro-credor-ces',
      name: 'parametroCredorBancarioCES',
      component: ParametroCredorBancarioCES,
      meta: {
        breadcrumb: true,
        label: 'Parâmetros de Credor e Dados Bancários CES',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR']
      }
    },
    {
      path: '/pesquisas',
      name: 'pesquisas',
      component: Pesquisas,
      meta: {
        breadcrumb: true,
        label: 'Pesquisas',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR', 'SFEPGE-CES']
      }
    },
    {
      path: '/painel-usuario',
      name: 'painelUsuario',
      component: PainelUsuario,
      meta: {
        breadcrumb: true,
        label: 'Painel do Usuário',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
      }
    },
    {
      path: '/honorarios',
      name: 'honorarios',
      component: IniciarRequisicao,
      meta: {
        breadcrumb: true,
        label: 'Gerar Requisição',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
      }
    },
    {
      path: '/honorarios-acao-judicial',
      name: 'honorariosAcaoJudicial',
      component: HonorariosAcaoJudicial,
      meta: {
        breadcrumb: true,
        label: 'Honorários De Ação Judicial',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
      }
    },
    {
      path: '/comunicacao-transferencia',
      name: 'ComunicacaoTransferencia',
      component: ComunicacaoTransferencia,
      meta: {
        breadcrumb: true,
        label: 'Comunicação de Transferência de Honorários',
        requiresAuth: true,
        groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
      }
    },
    {
        path: '/boletos-nao-encontrados',
        name: 'boletosNaoEncontrados',
        component: ListarBoletosNaoEncontrados,
        meta: {
            breadcrumb: true,
            label: 'Gestão de Boletos Não Encontrados',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/consulta-cda-webservice',
        name: 'consultaCdaWebservice',
        component: ListarCdaWebService,
        meta: {
            breadcrumb: true,
            label: 'Consulta CDA WebService SEFA',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/migracao-guias',
        name: 'migracaoGuias',
        component: ListarMigracaoGuias,
        meta: {
            breadcrumb: true,
            label: 'Migração de Guias do Sistema Antigo',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/access_token=*',
        name: 'access_token',
        meta: {
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
        }
    },
    {
        path: '/honorarios-protesto',
        name: 'honorariosProtesto',
        component: HonorariosProtesto,
        meta: {
            breadcrumb: true,
            label: 'Honorários De Protesto',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
        }
    },
    {
        path: '/honorarios-ef-sefa',
        name: 'eonorariosExecucaoFiscalSefa',
        component: HonorariosExecucaoFiscalSefa,
        meta: {
            breadcrumb: true,
            label: 'Honorários De Execução Fiscal Da Sefa',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
        }
    },
    {
        path: '/comunicacao-transferencia-ef-sefa', 
        name: 'comunicacaoTransferenciaExecucaoFiscalSefa',
        component: ComunicacaoTransferenciaExecucaoFiscalSefa,
        meta: {
            breadcrumb: true,
            label: 'Comunicação de Transferência de Honorários de Execução Fiscal D.A. SEFA Realizada',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO','SFEPGE-GOFS','SFEPGE-TESOUREIRO','SFEPGE-PROCURADOR']
        }
    },
    {
        path: '/trp',
        name: 'trp',
        component: Trp,
        meta: {
            breadcrumb: true,
            label: 'TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-ADMINISTRATIVO', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
        }
    },
    {
        path: '/tipo-trp',
        name: 'tipo-trp',
        component: ListarTipoTrp,
        meta: {
            breadcrumb: true,
            label: 'MANTER TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/tipo-trp/incluir',
        name: 'tipo-trp-incluir',
        component: TipoTrpEditar,
        meta: {
            breadcrumb: true,
            label: 'MANTER TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/tipo-trp/editar',
        name: 'tipo-trp-editar',
        component: TipoTrpEditar,
        meta: {
            breadcrumb: true,
            label: 'MANTER TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/tipo-trp/exibir',
        name: 'tipo-trp-exibir',
        component: TipoTrpExibir,
        meta: {
            breadcrumb: true,
            label: 'MANTER TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/cancelar-trp',
        name: 'cancelar-trp',
        component: ListarCancelarTrp,
        meta: {
            breadcrumb: true,
            label: 'CANCELAR TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
    {
        path: '/carga-refis',
        name: 'carga-refis',
        component: ListarCargaRefis,
        meta: {
            breadcrumb: true,
            label: 'Carga Refis',
            requiresAuth: true,
            groups: ['SFEPGE-ADMINISTRADOR']
        }
    },
      {
          path: '/salario-minimo',
          name: 'salario-minimo',
          component: ListarSalarioMinimo,
          meta: {
              breadcrumb: true,
              label: 'Salário Mínimo',
              requiresAuth: true,
              groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-TESOUREIRO']
          }
      },
      {
          path: '/salario-minimo/incluir',
          name: 'salario-minimo-incluir',
          component: SalarioMinimoEditar,
          meta: {
              breadcrumb: true,
              label: 'Incluir Salário Mínimo',
              requiresAuth: true,
              groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-TESOUREIRO']
          }
      },
      {
          path: '/salario-minimo/editar',
          name: 'salario-minimo-editar',
          component: SalarioMinimoEditar,
          meta: {
              breadcrumb: true,
              label: 'Editar Salário Mínimo',
              requiresAuth: true,
              groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-TESOUREIRO']
          }
      },
      {
        path: '/consulta-boleto-externo',
        name: 'consulta-boleto-externo',
        component: ConsultaBoletoExterno,
        meta: {
            label: 'Guia de Honorários SEFPGE',
            requiresAuth: false,
            public: true
        }
    },
    // error pages
    {
      path: '/accessdenied',
      name: 'AccessDenied',
      component: AccessDenied,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/*',
      name: 'NotFound',
      components: {
        secundario: NotFound,
        default: NotFound
      },
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('limparMensagens')

  // protected access
  if (to.meta.requiresAuth) {
  (async () => {
    if (await store.dispatch('authFilter')) {

    if (store.getters.isAuthenticated == true) {
        //root redirect
        if (to.path === "/" || to.path === "/home" || to.path.startsWith("/access_token")) {
            store.commit('setLayout', 'admin');
            let userData = JSON.parse(store.getters.getUser);
            if (userData.groups) {
                let permission = false;
                let pesquisa = false;
                let groupName = '';
                let groupsDashboard = ['SFEPGE-ADMINISTRADOR', 'SFEPGE-TESOUREIRO'];
                for (let i = 0; i < userData.groups.length; i++) {
                    groupName = userData.groups[i];
                    if (groupsDashboard.indexOf(groupName) != -1) {
                        permission = true;
                        break;
                    }
                    if (groupName == 'SFEPGE-CES') {
                        pesquisa = true;
                    }
                }
                if (permission) {
                    next("/painel-tesoureiro")
                } else if (pesquisa) {
                    next("/pesquisas")
                } else {
                    next("/painel-usuario")
                }
            }
        } else {
            if (to.meta.groups && to.meta.groups.length > 0) {
                let userData = JSON.parse(store.getters.getUser);
                if (userData.groups) {
                    let permission = false,
                        groupName = '';
                    for (let i = 0; i < userData.groups.length; i++) {
                        groupName = userData.groups[i];
                        if (to.meta.groups.indexOf(groupName) != -1) {
                            permission = true;
                            break;
                        }
                    }
                    if (permission) { //permission granted
                        store.commit('setLayout', 'admin');
                        next();
                        return;
                    } else { //permission denied
                        store.commit("limparUserState");
                        store.commit('setLayout', 'blank');
                        next("/accessdenied");
                        return;
                    }
                }
            }
        }
    } else {
      store.commit("limparUserState");
      store.commit('setLayout', 'blank');
      next("/accessdenied");
      return;
    }
  }
})();
  } 

//Monitoring, Notfound, AccessDenied
if (to.name == "NotFound" || to.name == "AccessDenied") {
  store.commit('setLayout', 'blank');
  next()
  return
}

//public access
if(to.meta.public){
  store.commit('setLayout', 'consulta-boleto')
  next('/consulta-boleto-externo')
  return;
}
  next()
  return;
});

export default router;
